import { render, staticRenderFns } from "./QuoteBlockForAdmin.vue?vue&type=template&id=22909034&scoped=true"
import script from "./QuoteBlockForAdmin.vue?vue&type=script&lang=js"
export * from "./QuoteBlockForAdmin.vue?vue&type=script&lang=js"
import style0 from "./QuoteBlockForAdmin.vue?vue&type=style&index=0&id=22909034&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22909034",
  null
  
)

export default component.exports